import { GlobalDnc } from '@Containers/Dnc';

const GlobalDncPage: React.FunctionComponent = (): JSX.Element => <GlobalDnc />;

export default GlobalDncPage;
